<template>
  <div v-if="fissionId" class="gift-enter" @click="redirect">
    <!--    <img src="../../../../ui/activity/appstore_chargecard/images/gift-enter.png" alt="" />-->
    <img class="gift" style="width: 1rem" src="../../../../ui/activity/appstore_chargecard/images/gift-enter02.png" alt="" />
    <!-- <img class="tiger cake" src="../../../../ui/activity/appstore_chargecard/images/laohu.png" alt="" /> -->
  </div>
</template>

<script>
import useGiftEnter from "./useGiftEnter"
import { getParam } from "../../../utils/url"

export default {
  name: "GiftEnter",
  setup() {
    const { fissionId } = useGiftEnter()
    const redirect = () => {
      location.href = getParam("store_config_env")
        ? `//pay.qq.com/h5/store/apple-card/experience-coupon.html?fission_id=${fissionId.value}&pf=${getParam("pf")}&sandbox=${getParam(
            "sandbox"
          )}&store_config_env=${getParam("store_config_env")}`
        : `//pay.qq.com/h5/store/apple-card/coupon.html?fission_id=${fissionId.value}&pf=${getParam("pf")}&sandbox=${getParam("sandbox")}`
    }
    return {
      fissionId,
      redirect
    }
  }
}
</script>

<style scoped></style>
